import React from "react";

interface IProps {
    enable: boolean,
    rotate?: string,
    onClick: () => void,
}

export default function PageButton(props: IProps) {
    const { enable, rotate = "", onClick } = props
    return (
        <button onClick={onClick} type={"button"} className={`${enable ? "hover:bg-theme-blue-10" : ""} max-w-max transform rounded-full`}>
            <svg className={`transform ${rotate}`} width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M9 18.8643L15.0259 12.8643L9 6.86426" stroke={enable ? "#2F80ED" : "#B0B1B2"} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
        </button>
    )
}